import FeatureGates from '@atlaskit/feature-gate-js-client';

interface IdleDetectorOptions {
	/** Callback to invoke when idle timeout elapses */
	onIdle: () => void;
}

/** Default timeout in milliseconds. */
export const DEFAULT_TIMEOUT_MS = 2000;

function isNumber(value: unknown): value is number {
	return typeof value === 'number';
}

function getExperimentValue(key: string, defaultValue: number): number {
	// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
	return FeatureGates.getExperimentValue('platform_editor_ai_quick_prompt', key, defaultValue, {
		typeGuard: isNumber,
	});
}

function getTimeoutMs(): number {
	return getExperimentValue('timeout', DEFAULT_TIMEOUT_MS);
}

export class IdleDetector {
	private timeoutMs: number;
	private timerId: ReturnType<typeof setTimeout> | null = null;
	private onIdle: () => void;
	private destroyed = false;

	constructor(options: IdleDetectorOptions) {
		this.timeoutMs = getTimeoutMs();
		this.onIdle = options.onIdle;
	}

	/** Reset the idle timer */
	reset(): void {
		if (this.destroyed) {
			return;
		}
		if (this.timerId !== null) {
			clearTimeout(this.timerId);
		}
		this.timerId = setTimeout(() => {
			this.timerId = null;
			this.onIdle();
		}, this.timeoutMs);
	}

	/** Cancel pending timer and clean up */
	destroy(): void {
		this.destroyed = true;
		if (this.timerId !== null) {
			clearTimeout(this.timerId);
			this.timerId = null;
		}
	}
}
